<template>
  <div class="page">
    <div
      class="card"
      :class="{ '-loading': loading }"
    >
      <loader v-if="loading"></loader>

      <div class="header">
        <div class="description">
          <h2 class="title">Histórico</h2>
          <p class="subtitle"> Nesta tela você visualiza todo o histórico de compras de créditos realizadas.</p>
        </div>
      </div>
      <div
        class="body"
        :class="{ '-no-padding': !errors.cantLoadPurchasesList }"
      >
        <div class="alert -danger" v-if="errors.cantLoadPurchasesList">
          <p class="title">Ops!</p>

          <p>
            Infelizmente aconteceu um erro ao tentar carregar o seu histórico,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>

        <template v-if="!errors.cantLoadPurchasesList">
          <table class="history">
            <thead>
            <tr>
              <th>Data da Compra</th>
              <th>Meio de Pagamento</th>
              <th>Descrição</th>
              <th>Valor</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="purchase in purchases.data">
              <td>{{ purchase.created_at | dateFormat('DD/MM/YY HH:mm') }}</td>
              <td><purchase-payment-method :payment-method="purchase.payment_method"/></td>
              <td>{{ purchase.description }}</td>
              <td>R$ {{ purchase.price | currency }}</td>
              <td><purchase-status-badge :status="purchase.status || 'WAITING'"/></td>
            </tr>
            </tbody>
          </table>

          <div class="navHistory">
            <pagination
              :limit="1"
              :data="purchases"
              @pagination-change-page="fetchPurchasesList({ page: $event })"
            >
              <span slot="prev-nav">Anterior</span>
              <span slot="next-nav">Próxima</span>
            </pagination>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import currency from '@/support/filters/currency';
import dateFormat from '@/support/filters/dateFormat';
import Loader from '@/support/components/Loader.vue';
import PurchaseStatusBadge from '@/history/components/PurchaseStatusBadge.vue';
import PurchasePaymentMethod from '@/history/components/PurchasePaymentMethod.vue';

export default {
  name: 'Index',

  data() {
    return {
      loading: false,
      errors: {
        cantLoadPurchasesList: false,
      },
    };
  },

  methods: {
    /**
     * Fetch the  purchases list.
     *
     * @param page
     * @returns {Promise<void>}
     */
    async fetchPurchasesList({ page }) {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch('history/fetchPurchasesList', { page });
      } catch {
        this.errors.cantLoadPurchasesList = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the all errors to initial value.
     */
    resetErrors() {
      this.errors.cantLoadPurchasesList = false;
    },
  },

  computed: {
    ...mapState('history', {
      purchases: 'purchases',
    }),
  },

  mounted() {
    this.fetchPurchasesList({ page: 1 });
  },

  filters: {
    currency,
    dateFormat,
  },

  components: {
    Pagination,
    Loader,
    PurchaseStatusBadge,
    PurchasePaymentMethod,
  },
};
</script>

<style lang="scss" scoped>
.page {
  > .card {
    > .body {
      > .navHistory {
        @apply flex;
        @apply justify-center;
      }
    }
  }
}
</style>
